import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  loginId:any;
  email:any;
  name:any;
  jwtToken:any;
  sSOToken:any;
  sTenantId:any;
  UserRefId:any;
  sPatnerID:any;
  PubUrlDetails : any;
  sRestSession:any;
  sAppToken: any;
  Product:any;
  isSSOEnabled: boolean = false;
  groupId:any;
  constructor() { }
}
